export class PlanFile {
  constructor(
    public fileName: string,
    public fileUrl: string
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/plan-file.ts